/* Extracted from sections/main-cart.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      var svgContent = btn.innerHTML;
      btn.textContent = '...';

      var variantId = btn.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'id=' + variantId + '&quantity=1'
      })
        .then(function (r) {
          if (!r.ok) throw new Error();
          btn.textContent = btn.getAttribute('data-text-added');

          /* Re-render cart section via Section Rendering API */
          var sectionEl = document.querySelector('cart-items-component');
          var sectionId = sectionEl && sectionEl.dataset.sectionId;
          if (!sectionId) { location.reload(); return; }

          return fetch('/?sections=' + sectionId)
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              var html = sections[sectionId];
              if (html) {
                var tmp = document.createElement('div');
                tmp.innerHTML = html;
                var newContent = tmp.querySelector('cart-items-component');
                if (newContent && sectionEl) {
                  sectionEl.innerHTML = newContent.innerHTML;
                }
              }
            });
        })
        .catch(function () {
          btn.innerHTML = svgContent;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    });
  })();
